import { combineReducers, AnyAction, CombinedState } from '@reduxjs/toolkit';

import { homeReducer } from '../features/Home/homeSlice';

export const appReducer = combineReducers({
  home: homeReducer,
});

const rootReducer = (state: CombinedState<any>, action: AnyAction) => {
  return appReducer(state, action);
};

export default rootReducer;
